import { useWizardStep } from '@apply/components';
import { useStandardLoanStore } from '../../../../state/standardLoanStore';
import { getSetupAndBorrowerProgress } from './functions/getSetupAndBorrowerProgress';
import { Setup } from './Setup/Setup';
import { Borrower } from './Borrower/Borrower';

/**
 * The "Setup & Borrower" step. Enables Save & Continue once every currently-required field is complete.
 */
export const SetupAndBorrower = () => {
    const setup = useStandardLoanStore((state) => state.setup);
    const setupLoanContext = useStandardLoanStore((state) => state.setupLoanContext);
    const selectedTermKey = useStandardLoanStore((state) => state.selectedTermKey);
    const borrower = useStandardLoanStore((state) => state.borrower);
    const borrowerLoanContext = useStandardLoanStore((state) => state.borrowerLoanContext);
    const { numberComplete, total } = getSetupAndBorrowerProgress({
        setup,
        setupLoanContext,
        selectedTermKey,
        borrower,
        borrowerLoanContext,
    });

    useWizardStep({ enableSaveAndContinue: numberComplete === total });

    return (
        <>
            <Setup />
            <Borrower />
        </>
    );
};
